module.exports = __webpack_public_path__ + "static/media/vicepresident.04e0dd86.jpg";